var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "NextReviewerModal",
    _vm._b(
      {
        ref: "modal",
        attrs: {
          title: _vm.$t("directory.modal.selectNextReviewer"),
          asyncSelectOptions: function () {
            return _vm.getOptions()
          },
          required: true,
        },
        on: { onOkClick: _vm.save },
      },
      "NextReviewerModal",
      _vm.$attrs,
      false
    ),
    [
      _c("template", { slot: "title" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("directory.modal.reAssign")) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.histories.length
        ? _c(
            "template",
            { slot: "add-text" },
            [
              _c("HKLGrayHint", [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("directory.modal.assignedHistory"))),
                ]),
                _vm._v(" "),
                _c(
                  "ol",
                  _vm._l(_vm.histories, function (item, index) {
                    return _c("li", { key: index }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("action.assignedBy", [
                              item.displayName,
                              item.createdAt,
                            ])
                          ) +
                          "\n        "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }